import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';
import Footer from '@/pages/LandingPage/components/Footer';
import useNoteArticleData from '@/hooks/use-note-article-data';
import NavigationBar from './components/NavigationBar';
import TopBanner from './components/TopBanner';
import Features from './components/Features';
import SimpleSteps from './components/SimpleSteps';
import Blog from './components/Blog';
import useScrollTo from '@/hooks/use-scroll-to';
import Pricing from './components/Pricing';
import Showcases from './components/Showcases';

const LandingPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const articles = useNoteArticleData();
  const scrollToShowcases = useScrollTo();
  const scrollToFeatures = useScrollTo();
  const scrollToPricing = useScrollTo();

  const CORPORATE_SITE_ROOT =
    i18n.language === 'en' ? 'https://corporate.pretiaar.com/en' : 'https://corporate.pretiaar.com';
  return (
    <Box as="main" scrollSnapType="y mandatory">
      <NavigationBar
        scrollToFeatures={scrollToFeatures.trigger}
        scrollToPricing={scrollToPricing.trigger}
        scrollToShowcases={scrollToShowcases.trigger}
        t={t}
      />
      <TopBanner language={i18n.language as 'jp' | 'en'} t={t} />
      <Features ref={scrollToFeatures.ref} t={t} />
      <SimpleSteps t={t} />
      {/* <Showcases ref={scrollToShowcases.ref} t={t} /> */}
      <Blog articles={articles} t={t} />
      <Pricing ref={scrollToPricing.ref} language={i18n.language as 'jp' | 'en'} t={t} />
      <Footer corporateSiteRoot={CORPORATE_SITE_ROOT} />
    </Box>
  );
};

export default LandingPage;
